module.exports = __webpack_public_path__ + "static/media/say.fa02d893.png";